import { combineReducers } from 'redux';
import initialState from '../../store/initialState';


import * as types from '../../constants/actionTypes'


const fabric = (state = initialState.config.fabric, action) => {
  if (action.type == types.FABRIC_CONFIG_RECEIVED) {
    return action.data;
  }
  return state;
}

const attr = (state = initialState.config.attr, action) => {
  switch (action.type) {
    case types.ATTR_CONFIG_RECEIVED: {
      return action.data;
    }
  }
  return state;
}

const inStock = (state = initialState.config.inStock, action) => {
  if (action.type == types.IN_STOCK_CONFIG_RECEIVED) {
    return action.data;
  }
  return state;
}


const presets = (state = initialState.config.presets, action) => {
  if (action.type == types.PRESET_CONFIG_RECEIVED) {
    return action.data;
  }
  return state;
}

const layout = (state = initialState.config.layout, action) => {
  switch (action.type) {
    case (types.ATTR_CONFIG_RECEIVED): {
      const attrEnums = action.data.enums;
      const formattedState = Object.assign(state);

      for (let section in formattedState.sections) {
        const layoutSection = formattedState.sections[section];
        const layoutEnums = layoutSection.enums;

        for (let ce in layoutEnums) {


          const layoutEnum = layoutEnums[ce];
          let attrEnum = attrEnums[ce];

          if (layoutEnum.attrGroup) {
            attrEnum = action.data[layoutEnum.attrGroup][ce];
          }

          if (!attrEnum) {
            continue;
          }

          const { values, ...others } = attrEnum;

          layoutEnum = { ...layoutEnum, ...others };
          if (layoutEnum.values) {
            layoutEnum.values = values;
          }

          layoutEnums[ce] = layoutEnum;
        }
      }

      return formattedState;
    }
    default:

      return state;
  }
}

export const skeleton = (state = initialState.config.skeleton, action) => {
  const { type, value, name, data } = action;
  switch (type) {

    case 'UPDATE_SELECTED_DETAIL': {
      return {
        ...state,
        [name]: data.attrValue,
      }
    }

    //todo: Все ткани должны соответствовать основной ткани
    case 'UPDATE_PRODUCT_BY_FABRIC': {
      return {
        ...state,
        fabric: value,
        sleeveFabric: value,
        fasteningFabric: value,
        collarStandFrontFabric: value,
        fasteningThreadsFabric: value,
        doubleCollarContrastFabric: value,
        threebleCollarContrastFabric: value,
        pocketsFabric: value,
        epaulettesFabric: value,
        patchFabric: value,
        contrastFabric: value,
        'collarFabric': value,
        'cuffFabric': value,
        'cuffTurnFabric': value,
        'collarStandFabric': value,
        'fasteningButtonsFabric': value,
      }
    }

    //todo: За исключением выбранных пользователем контрастов
    case 'UPDATE_PRODUCT_BY_CONTRAST': {
      return {
        ...state,
        [name]: value,
      };
    }

    case 'UPDATE_PRODUCT_BY_BUTTON': {
      return {
        ...state,
        buttons: value,
      }
    }

    default: {
      return state;
    }
  }
}


export default combineReducers({
  fabric,
  //buttons,
  attr,
  inStock,
  presets,
  layout,
  sizes: () => initialState.config.sizes,
  skeleton,
});
